import { FC } from "react";
import images from "../../assets/images";
import './TeacherStudentSettingsHeader.scss';
import { useNavigate } from "react-router-dom";
import { STUDENT_ROLE } from "../../utils/constants";
import { useAppSelector } from "../../redux/app/hooks";

interface propsType {
    title: string;
    subTitle?: string;
    isEdit?: boolean;
    setIsEdit?: (val: boolean) => void;
    displayForm?: boolean;
    setDisplayForm?: (val: boolean) => void;
}
  
const TeacherStudentSettingsHeader: FC<propsType> = ({ title, subTitle }) => {

    const { backArrow } = images;
    const navigate = useNavigate();
    const role = useAppSelector((state) => state.auth.role);

    const handleClickBack = () => {
        if (role === STUDENT_ROLE) {
            navigate('/student-settings');
        }
        else {
            navigate('/teacher-settings');
        }
    }

    return (
        <div className="settingsHeader">
            <div className="titleContainer">
                <div className="backArrow">
                    <img src={backArrow} className="backIcon" onClick={handleClickBack} alt="backArrowIcon"/>
                </div>
                <div className="contentContainer">
                    <div className="title">{ title }</div>
                    <div className="subTitle">{ subTitle }</div>
                </div>
            </div>
        </div>
    )
}

export default TeacherStudentSettingsHeader;